import { render, staticRenderFns } from "./amap-choose.vue?vue&type=template&id=6f53e2cd&scoped=true"
import script from "./amap-choose.vue?vue&type=script&lang=js"
export * from "./amap-choose.vue?vue&type=script&lang=js"
import style0 from "./amap-choose.vue?vue&type=style&index=0&id=6f53e2cd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f53e2cd",
  null
  
)

export default component.exports